import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import { Carousel } from '@cotyorg/ccx-organism-carousel';
import Picture from '@cotyorg/ccx-atoms/Picture';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import { trackCarouselClickEvent } from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/carousel';

export const getSkuDetails = ({ swatches, gallerySku }) => {
  const skuDetails = swatches.find(({ sku }) => sku === gallerySku);

  return {
    name: R.prop('itemName', skuDetails),
    size: R.prop('skuSize', skuDetails),
  };
};

const ProductGallery = ({
  swatches = [],
  productGallery = [],
  currentBreakpoint = '',
}) => (
  <div className="product-gallery">
    <Carousel
      headingLevel={3}
      carouselsStoreDataKey="productGallery"
      rightChevronIconSrc="/ccx-files/assets/arrow-right.svg"
      leftChevronIconSrc="/ccx-files/assets/arrow-left.svg"
      onIndexChange={({ type, index, isForward }) =>
        trackCarouselClickEvent({
          page: 'product',
          carousel: 'productGallery',
          type,
          index,
          isForward,
        })
      }
    >
      {productGallery.map((item) => (
        <div key={uuid()}>
          <Picture
            doNotLazyLoad
            currentBreakpoint={currentBreakpoint}
            src={R.path(['images', 0, 'src'], item)}
            srcset={R.path(['images', 0, 'srcset'], item)}
            alt={R.path(['images', 0, 'alt'], item)}
          />

          <div className="gallery-content text--center">
            <Heading extraClass="gallery-content__heading" level={2}>
              {R.prop(
                'name',
                getSkuDetails({ swatches, gallerySku: item.sku })
              )}
            </Heading>
            <Paragraph>
              {R.prop(
                'size',
                getSkuDetails({ swatches, gallerySku: item.sku })
              )}
            </Paragraph>
          </div>
        </div>
      ))}
    </Carousel>
  </div>
);

ProductGallery.propTypes = {
  productGallery: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      srcset: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          src: PropTypes.string,
        })
      ),
    })
  ),
  swatches: PropTypes.arrayOf(PropTypes.object),
  currentBreakpoint: PropTypes.string,
};

export default ProductGallery;
